function stickyFooterInit () {
    const $navbarFooter = document.querySelector('#navbar-footer');
    const navbarFooterLinks = Array.from(document.querySelectorAll('.navbar-footer__bar-link'));

    if ($navbarFooter && navbarFooterLinks) {
        // Set active item
        const navbarFooterLinkActiveClassname = 'navbar-footer__bar-link--is-active';
        let initialLinkActive = null;
        const currentPathname = document.location.pathname;
        navbarFooterLinks.forEach((link) => {
            link.classList.remove(navbarFooterLinkActiveClassname);

            if (link.href.replace(document.location.origin, '') === currentPathname) {
                initialLinkActive = link;
            }
        });

        if (initialLinkActive) {
            initialLinkActive.classList.add(navbarFooterLinkActiveClassname);
        }
        
        // Menu toggle
        const $navbarFooterBarNav = $navbarFooter.querySelector('#navbar-footer-bar-nav');
        const $navbarFooterNav = $navbarFooter.querySelector('#navbar-footer-nav');
        const $navbarFooterNavOverlay = $navbarFooter.querySelector('#navbar-footer-nav-overlay');
        const $navbarFooterNavClose = $navbarFooter.querySelector('#navbar-footer-nav-close');
        
        if ($navbarFooterBarNav && $navbarFooterNav) {
            const navbarFooterNavVisiblityClassname = $navbarFooterNav.dataset.visibilityClassname;
            const navbarFooterBodyVisiblityClassname = $navbarFooterNav.dataset.bodyVisibilityClassname;
            
            $navbarFooterBarNav.addEventListener('click', (event) => {
                event.preventDefault();

                if ($navbarFooterNav.classList.contains(navbarFooterNavVisiblityClassname)) {
                    $navbarFooterNav.classList.remove(navbarFooterNavVisiblityClassname);
                    document.body.classList.remove(navbarFooterBodyVisiblityClassname);

                    navbarFooterLinks.forEach((link) => link.classList.remove(navbarFooterLinkActiveClassname));
                    if (initialLinkActive) {
                        initialLinkActive.classList.add(navbarFooterLinkActiveClassname);
                    }
                } else {
                    $navbarFooterNav.classList.add(navbarFooterNavVisiblityClassname);
                    document.body.classList.add(navbarFooterBodyVisiblityClassname);

                    navbarFooterLinks.forEach((link) => link.classList.remove(navbarFooterLinkActiveClassname));
                    $navbarFooterBarNav.classList.add(navbarFooterLinkActiveClassname);
                }
            });

            const $navbarFooterCloseElements = [$navbarFooterNavOverlay, $navbarFooterNavClose];
            $navbarFooterCloseElements.forEach(($closeElement) => {
                $closeElement.addEventListener('click', (event) => {
                    event.preventDefault();

                    $navbarFooterNav.classList.remove(navbarFooterNavVisiblityClassname);
                    document.body.classList.remove(navbarFooterBodyVisiblityClassname);

                    navbarFooterLinks.forEach((link) => link.classList.remove(navbarFooterLinkActiveClassname));
                    if (initialLinkActive) {
                        initialLinkActive.classList.add(navbarFooterLinkActiveClassname);
                    }
                });
            });
        }

        // Menu Height
        const $navbarFooterBarNavInner = $navbarFooterNav.querySelector('#navbar-footer-inner');
        const $navbarFooterBar = $navbarFooter.querySelector('#navbar-footer-bar');
        const $navbar = document.querySelector('#wrapper-navbar');
        if ($navbarFooterNav && $navbarFooterBar && $navbar) {
            let navbarFooterNavHeight = window.innerHeight - ($navbarFooterBar.offsetHeight + $navbar.offsetHeight + 10);

            const $wpAdminBar = document.querySelector('#wpadminbar');
            if ($wpAdminBar) {
                navbarFooterNavHeight = navbarFooterNavHeight- $wpAdminBar.offsetHeight;
            }
            
            $navbarFooterBarNavInner.style.maxHeight = navbarFooterNavHeight + 'px';
        }

        // Menu walker
        const footerMenus = Array.from($navbarFooter.querySelectorAll('.menu'));
        if (footerMenus.length) {
            let submenuIndex = 0;
            footerMenus.forEach((menu) => {
                const footerSubmenus = Array.from(menu.querySelectorAll('.sub-menu'));
                if (footerSubmenus.length) {
                    footerSubmenus.forEach((submenu) => {
                        const isRoot = submenu.parentElement.parentElement.classList.contains('menu');
                        const submenuDepth = (isRoot || submenu.querySelector('.sub-menu')) ? 1 : 2;
                        const $submenuLink = submenu.parentElement.querySelector('a');
                        $submenuLink.dataset.submenuId = submenuIndex;
                        $submenuLink.dataset.submenuIsRoot = isRoot;
                        $submenuLink.dataset.submenuDepth = submenuDepth;
                        submenu.dataset.submenuIsRoot = isRoot;
                        submenu.dataset.submenuId = submenuIndex;
                        submenu.dataset.submenuDepth = submenuDepth;
                        submenu.dataset.submenuBackTitle = submenuDepth > 1 ? submenu.parentElement.parentElement.parentElement.querySelector('a').innerText : 'MENU';
                        submenu.dataset.submenuTitle = $submenuLink.innerText;
                        submenu.classList.add('d-none');

                        submenuIndex += 1;
                    });
                }
            });

            const submenuRootLinks = Array.from($navbarFooter.querySelectorAll('a[data-submenu-id][data-submenu-is-root="true"]'));
            submenuRootLinks.forEach((link) => {
                link.addEventListener('click', (event) => {
                    event.preventDefault();
                    event.stopPropagation();

                    stickyFooterOpenSubmenu(link.dataset.submenuId);
                });
            });
            

            const navbarFooterSubmenus = Array.from($navbarFooter.querySelectorAll('.navbar-footer__nav-submenu'));
            navbarFooterSubmenus.forEach(($navFooterSubmenu) => {
                const $navFooterSubmenuBack = $navFooterSubmenu.querySelector('.navbar-footer__nav-submenu-back');
                const $navFooterSubmenuTitle = $navFooterSubmenu.querySelector('.navbar-footer__nav-submenu-title');
                const $navFooterSubmenuContent = $navFooterSubmenu.querySelector('.navbar-footer__nav-submenu-content');
                
                $navFooterSubmenuBack.addEventListener('click', (event) => {
                    event.preventDefault();
                    $navFooterSubmenu.classList.remove('navbar-footer__nav-submenu--is-visible');

                    $navFooterSubmenuTitle.innerText = '';
                    $navFooterSubmenuContent.innerHTML = '';
                });
            });
        }
    }
}

function stickyFooterOpenSubmenu (submenuId) {
    const $submenu = document.querySelector('.sub-menu[data-submenu-id="'+submenuId+'"]');
    if ($submenu) {
        const submenuDepth = $submenu.dataset.submenuDepth;
        const $navbarFooterSubmenu = document.querySelector('#navbar-footer-submenu-depth-'+submenuDepth);
        const $navFooterSubmenuBack = $navbarFooterSubmenu.querySelector('.navbar-footer__nav-submenu-back');
        const $navFooterSubmenuTitle = $navbarFooterSubmenu.querySelector('.navbar-footer__nav-submenu-title');
        const $navFooterSubmenuContent = $navbarFooterSubmenu.querySelector('.navbar-footer__nav-submenu-content');

        if (parseInt(submenuDepth) > 1) {
            $navFooterSubmenuBack.innerText = $submenu.dataset.submenuBackTitle;
        }

        $navFooterSubmenuTitle.innerText = $submenu.dataset.submenuTitle;
        $navFooterSubmenuContent.innerHTML = $submenu.innerHTML;

        const submenuLinks = Array.from($navFooterSubmenuContent.querySelectorAll('a[data-submenu-id][data-submenu-depth="2"]'));
        submenuLinks.forEach((link) => {
            link.addEventListener('click', (event) => {
                event.preventDefault();
                event.stopPropagation();

                stickyFooterOpenSubmenu(link.dataset.submenuId);
            });
        });

        $navbarFooterSubmenu.classList.add('navbar-footer__nav-submenu--is-visible');
    }
}

document.addEventListener("DOMContentLoaded", () => {
    if (isMobile()) {
        stickyFooterInit();
    }
});